/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import React, { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import clsx from 'clsx'
import UiDropdownItemsList from './UiDropdownComponents/UiDropdownItemsList'

export interface UiDropdownItem {
    label: string
    onClick?: () => void
    icon?: React.ComponentType<{ className?: string }> | React.ReactNode
    disabled?: boolean
    variant?: 'default' | 'danger'
}

interface UiDropdownProps {
    trigger: React.ReactNode
    items: UiDropdownItem[]
    align?: 'left' | 'right'
    className?: string
}

const UiDropdown: React.FC<UiDropdownProps> = ({
    trigger,
    items,
    align = 'right',
    className,
}) => {
    return (
        <Menu
            as="div"
            className={clsx('UiDropdown relative inline-block text-left', className)}
        >
            <div>
                <Menu.Button className="inline-flex w-full justify-center focus:outline-none">
                    {trigger}
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items
                    className={clsx(
                        'absolute z-50 mt-2 w-56 origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black/5 focus:outline-none dark:bg-gray-950 dark:ring-white/10',
                        align === 'right' ? 'right-0' : 'left-0'
                    )}
                >
                    <div className="p-1">
                        <UiDropdownItemsList items={items} />
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    )
}

export default UiDropdown
